/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    return hash({
      learnerFields: this.store.query('people-schema/field', {
        personType: PersonType.LEARNER,
      }),
      caregiverFields: this.store.query('people-schema/field', {
        personType: PersonType.CAREGIVER,
      }),
      medicalFields: this.store.query('people-schema/field', {
        personType: PersonType.DOCTORS_AND_SPECIALISTS,
      }),
      staffFields: this.store.query('people-schema/field', {
        personType: PersonType.STAFF,
      }),
      fieldGroups: this.store.findAll('people-schema/group'),
      people: this.store.query('person', {
        type: PersonType.LEARNER,
        includeFormer: true,
      }),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
